import { transformKeysNested } from './iteration.esm.js';

function snakeToCamelCase(snake) {
    return snake.replaceAll(/(_\w)/g, function(m) {
        return m[1].toUpperCase(); // eslint-disable-line @typescript-eslint/no-non-null-assertion
    });
}
function snakeToCamelCaseKeys(object, options) {
    return transformKeysNested(object, snakeToCamelCase, options);
}
function snakeToCamelCaseArray(array) {
    return array.map(function(item) {
        if (item == null) {
            return item;
        }
        if (typeof item === "object") {
            return Array.isArray(item) ? snakeToCamelCaseArray(item) : snakeToCamelCaseKeys(item);
        }
        return item;
    });
}
function camelToSnakeCase(camel) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_separateLettersAndDigits = options.separateLettersAndDigits, separateLettersAndDigits = _options_separateLettersAndDigits === void 0 ? false : _options_separateLettersAndDigits;
    var result = camel.replaceAll(/[\w]([A-Z])/g, function(m) {
        return "".concat(m[0], "_").concat(m[1]);
    });
    if (separateLettersAndDigits) {
        result = result.replaceAll(/(\d)([a-zA-Z])/g, "$1_$2");
        result = result.replaceAll(/([a-zA-Z])(\d)/g, "$1_$2");
    }
    return result.toLowerCase();
}
function camelToSnakeCaseKeys(object) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return transformKeysNested(object, function(camel) {
        return camelToSnakeCase(camel, options);
    });
}
function camelToSnakeCaseArray(array) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return array.map(function(item) {
        if (item == null) {
            return item;
        }
        if (typeof item === "object") {
            return Array.isArray(item) ? camelToSnakeCaseArray(item, options) : camelToSnakeCaseKeys(item, options);
        }
        return item;
    });
}
function camelToKebabCase(camel) {
    return camel.replaceAll(/[\w]([A-Z])/g, function(m) {
        return "".concat(m[0], "-").concat(m[1]);
    }).toLowerCase();
}
function camelToPascalCase(camel) {
    return camel.charAt(0).toUpperCase() + camel.slice(1);
}
function capitalizeWords(str) {
    return str.replaceAll(/^(\w)/g, function(c) {
        return c.toUpperCase();
    }).replaceAll(/[- ](\w)/g, function(c) {
        return c.toUpperCase();
    });
}
function snakeToPascalCase(snakeCaseString) {
    return snakeCaseString.trim().toLowerCase().split("_").reduce(function(pascal, word) {
        return pascal + word.charAt(0).toUpperCase() + word.slice(1);
    }, "");
}

export { camelToKebabCase, camelToPascalCase, camelToSnakeCase, camelToSnakeCaseArray, camelToSnakeCaseKeys, capitalizeWords, snakeToCamelCase, snakeToCamelCaseArray, snakeToCamelCaseKeys, snakeToPascalCase };
